import Layout from "../../layout/layout";

export default Layout;
